import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import PublicProfile from './pages/PublicProfile';
import ResetPassword from './pages/ResetPassword';
import MerchantBankLinked from './pages/MerchantBankLinked';
import MerchantCommissionPaid from './pages/MerchantCommissionPaid';
import ExtensionDownload from './pages/ExtensionDownload';
import About from './pages/About';
import HomeGate from './pages/Home';
import ShopGate from './pages/Shop';
import OfferDetailGate from './pages/OfferDetail';
import RewardsGate from './pages/Rewards';
import { FirstRewardGate, RewardItemGate, RewardPrizeGate } from './pages/RewardDetail';
import TravelGate from './pages/Travel';
import GamesGate from './pages/Games';
import ProfileGate from './pages/Profile';
import SettingsGate from './pages/Settings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Contact from './pages/Contact';
import './styles/App.css';

const ADMIN_ORIGIN = 'https://admin.gethomecrowd.com';

const ADMIN_PREFIXES = [
  '/staff',
  '/superuser',
  '/embed-tester',
  '/admin',
  '/onboarding',
  '/merchants',
  '/docs',
  '/early-access-overview',
  '/reward-selection',
  '/resources',
  '/preview',
];

function isAdminPath(pathname) {
  return ADMIN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

function AdminPathRedirect() {
  const location = useLocation();

  useEffect(() => {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return;
    if (!isAdminPath(location.pathname)) return;
    window.location.replace(
      `${ADMIN_ORIGIN}${location.pathname}${location.search}${location.hash}`
    );
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="app">
        <AdminPathRedirect />
        <Routes>
          <Route path="/login/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup/" element={<Signup />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password/" element={<ForgotPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/verify-email/" element={<VerifyEmail />} />
          <Route path="/mobile/verify-email" element={<VerifyEmail />} />
          <Route path="/mobile/verify-email/" element={<VerifyEmail />} />
          <Route path="/hc_prof/:fanId" element={<PublicProfile />} />
          <Route path="/hc_prof/:fanId/" element={<PublicProfile />} />
          <Route path="/mobile/u/:fanId" element={<PublicProfile />} />
          <Route path="/mobile/u/:fanId/" element={<PublicProfile />} />
          <Route path="/mobile/reset-password" element={<ResetPassword />} />
          <Route path="/mobile/reset-password/" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/" element={<ResetPassword />} />

          {/* Public: where Stripe returns a merchant after ACH bank setup. They
              have no Homecrowd account, so this must stay outside PrivateRoute. */}
          <Route path="/merchant/bank-linked" element={<MerchantBankLinked />} />
          <Route path="/merchant/bank-linked/" element={<MerchantBankLinked />} />
          <Route path="/merchant/commission-paid" element={<MerchantCommissionPaid />} />
          <Route path="/merchant/commission-paid/" element={<MerchantCommissionPaid />} />

          <Route path="/extension-download/" element={<ExtensionDownload />} />
          <Route path="/about/" element={<About />} />
          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions/" element={<TermsAndConditions />} />
          <Route path="/support/" element={<Contact />} />

          <Route path="/shop" element={<ShopGate />} />
          <Route path="/shop/" element={<ShopGate />} />
          <Route path="/shop/offer/:id" element={<OfferDetailGate />} />
          <Route path="/rewards" element={<RewardsGate />} />
          <Route path="/rewards/" element={<RewardsGate />} />
          <Route path="/rewards/item/:id" element={<RewardItemGate />} />
          <Route path="/rewards/prize/:type" element={<RewardPrizeGate />} />
          <Route path="/rewards/first/:id" element={<FirstRewardGate />} />
          <Route path="/travel" element={<TravelGate />} />
          <Route path="/travel/" element={<TravelGate />} />
          <Route path="/games" element={<GamesGate />} />
          <Route path="/games/" element={<GamesGate />} />
          <Route path="/profile" element={<ProfileGate />} />
          <Route path="/profile/" element={<ProfileGate />} />
          <Route path="/settings" element={<SettingsGate />} />
          <Route path="/settings/" element={<SettingsGate />} />
          <Route path="/" element={<HomeGate />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
